/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Simple_DescInputs */

const en_mk_nav_simple_desc = /** @type {(inputs: Mk_Nav_Simple_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with your needs, without writing code.`)
};

const id_mk_nav_simple_desc = /** @type {(inputs: Mk_Nav_Simple_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai dari kebutuhan, tanpa menulis kode.`)
};

/**
* | output |
* | --- |
* | "Start with your needs, without writing code." |
*
* @param {Mk_Nav_Simple_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_simple_desc = /** @type {((inputs?: Mk_Nav_Simple_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Simple_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_simple_desc(inputs)
	return en_mk_nav_simple_desc(inputs)
});